import React, { useEffect, useState } from 'react';
import moment from 'moment-with-locales-es6';
import { useSelector } from 'react-redux';
import { Icon } from '@iconify/react';
import client from '../../api';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import {
  hasCheckpointNoteContent,
  parseCheckpointNotePairs
} from '../../utils/parseCheckpointNote';

const CheckpointNote = ({ desc }) => {
  if (!hasCheckpointNoteContent(desc)) return null;

  const pairs = parseCheckpointNotePairs(desc);

  return (
    <div className='checkpoint-item__note'>
      <span className='checkpoint-item__note-label'>Catatan</span>
      {pairs ? (
        <dl className='checkpoint-item__note-pairs'>
          {pairs.map((pair, index) => (
            <div className='checkpoint-item__note-row' key={`${pair.label}-${index}`}>
              <dt>{pair.label}</dt>
              <dd>{pair.value}</dd>
            </div>
          ))}
        </dl>
      ) : (
        <div
          className='checkpoint-item__note-text'
          dangerouslySetInnerHTML={{ __html: desc }}
        />
      )}
    </div>
  );
};

const DataCheckpoint = ({ order_id }) => {
  const { user } = useSelector(state => state.auth);
  const [checkPoint, setCheckPoint] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCheckpoint = async () => {
    try {
      setLoading(true);
      const response = await client.get(`/api/customers/checkpoint/${order_id}`, {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${user.data.token}`
        }
      });
      setCheckPoint(response.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCheckpoint();
  }, [order_id]);

  if (loading) {
    return <div className='checkpoint-empty'>Memuat checkpoint...</div>;
  }

  if (!checkPoint.length) {
    return <div className='checkpoint-empty'>Belum ada data checkpoint</div>;
  }

  return (
    <ol className='checkpoint-list'>
      {checkPoint.map((row, i) => {
        const active = i === 0;
        const images = row.checkpoint_image
          ? row.checkpoint_image.split(',').map(img => img.replaceAll(' ', ''))
          : [];

        return (
          <li
            key={`${row.tanggal}-${i}`}
            className={`checkpoint-item${active ? ' is-active' : ''}`}>
            <div className='checkpoint-item__rail' aria-hidden>
              <Icon
                icon={
                  active
                    ? 'solar:check-circle-bold'
                    : 'solar:record-circle-bold'
                }
                width={18}
                height={18}
                className={`checkpoint-item__icon${
                  active ? ' is-active' : ''
                }`}
              />
              {i < checkPoint.length - 1 ? (
                <span className='checkpoint-item__line' />
              ) : null}
            </div>

            <div className='checkpoint-item__body'>
              <time className='checkpoint-item__date'>
                {moment(row.tanggal).locale('id').format('dddd, ll')}
              </time>

              {images.length > 0 && (
                <div className='checkpoint-item__photos'>
                  <PhotoProvider>
                    {images.map((img, index) => (
                      <PhotoView
                        key={`${img}-${index}`}
                        src={`${process.env.REACT_APP_CHECKPOINT_STORAGE}/${img}`}>
                        <button
                          type='button'
                          className='sb-btn sb-btn--photo'
                          style={{
                            display: index === 0 ? 'inline-flex' : 'none'
                          }}>
                          Foto Checkpoint
                          {images.length > 1 ? (
                            <span className='sb-btn__count'>{images.length}</span>
                          ) : null}
                        </button>
                      </PhotoView>
                    ))}
                  </PhotoProvider>
                </div>
              )}

              <p className='checkpoint-item__posisi'>{row.posisi || '-'}</p>

              <CheckpointNote desc={row.desc} />
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default DataCheckpoint;
